import {homepageBannerSideBarNav, AgentTopUpSideBarNav} from "./CHILDREN-SIDEBARNAV";

export function AdminMenuList(ammountInformation) {
    return {
        _name: "CSidebarNav",
        _children: [{
            _name: "CSidebarNavItem",
            name: "Dashboard",
            to: "/dashboard",
            icon: "cil-speedometer",
            badge: {
                color: "primary",
                text: "NEW"
            }
        },
            {
                _name: "CSidebarNavTitle",
                _children: ["Feature"]
            },
            {
                _name: "CSidebarNavItem",
                name: "Account",
                to: "/management/account",
                icon: "cil-user"
            },
            homepageBannerSideBarNav,
            {
                _name: "CSidebarNavItem",
                name: "Routes",
                to: "/management/routes",
                icon: "cil-map"
            },
            {
                _name: "CSidebarNavItem",
                name: "Industry",
                to: "/management/industry",
                icon: "cil-industry"
            },
            {
                _name: "CSidebarNavItem",
                name: "Shortlink",
                to: "/management/shortlink",
                icon: "cil-link"
            },
            {
                _name: "CSidebarNavItem",
                name: "Banner List",
                to: "/management/banner-list",
                icon: "cil-laptop"
            },
            {
                _name: "CSidebarNavItem",
                name: "Meta Info",
                to: "/management/meta-info",
                icon: "cil-globe-alt"
            },
            {
                _name: "CSidebarNavDropdown",
                name: "Agent",
                route: "/agent",
                icon: "cil-chart-pie",
                items: [{
                    name: "New Registration",
                    to: "/agent/new-registration",
                    badge: {
                        color: "danger",
                        text: ammountInformation.new,
                    }
                },
                    {
                        name: "Follow Up",
                        to: "/agent/follow-up",
                        badge: {
                            color: "danger",
                            text: ammountInformation.follow_up,
                            width: 20

                        }
                    },
                     AgentTopUpSideBarNav(ammountInformation.top_up),
                    {
                        name: "Listing",
                        to: "/agent/listing",
                        badge: {
                            color: "danger",
                            text: ammountInformation.listing
                        }
                    },
                    {
                        name: "Location",
                        to: "/agent/location"
                    },
                    {
                        name: "Network",
                        to: "/agent/network"
                    },
                    {
                        name: "Report Performance",
                        to: "/agent/performance"
                    }
                ]
            },
            {
                _name: "CSidebarNavItem",
                name: "Program",
                to: "/management/program",
                icon: "cil-layers"
            },
            {
                _name: 'CSidebarNavDropdown',
                name: "Event & Tips",
                to: "/management/corporate",
                icon: 'cil-file',
                items: [
                    {
                        name: 'Event & Tips',
                        to: "/management/corporate",
                    },
                    {
                        name: 'Podcast',
                        to: '/management/corporate-podcast'
                    },
                    {
                        name: 'Hashtag',
                        to: '/management/corporate-hashtag'
                    },
                    {
                        name: 'Category',
                        to: '/management/corporate-category'
                    },
                    {
                        name: 'Author',
                        to: '/management/corporate-author'
                    },
                ]
            },
            {
                _name: "CSidebarNavItem",
                name: "FAQ",
                to: "/management/faq",
                icon: "cil-cursor"
            },
            {
                _name: "CSidebarNavDropdown",
                name: "Career",
                route: "/career",
                icon: "cil-drop",
                items: [
                    {
                        name: "Division",
                        to: "/career/division"
                    },
                    {
                        name: "Job",
                        to: "/career/Job"
                    },
                    {
                        name: "Applicant",
                        to: "/career/applicant"
                    },
                    {
                        name: "Employee Branding",
                        to: "/career/employee-branding"
                    }
                ]
            },
            {
                _name: "CSidebarNavDropdown",
                name: "Business Inquiry",
                route: "/business_inquiry",
                icon: "cil-star",
                items: [{
                    name: "Pendaftaran",
                    to: "/business_inquiry/registration"
                },
                    {
                        name: "Listing",
                        to: "/business_inquiry/listing"
                    }
                ]
            },
            {
                _name: "CSidebarNavDropdown",
                name: "About Us",
                route: "/about-us",
                icon: "cil-puzzle",
                items: [{
                    name: "Press Release",
                    to: "/about-us/press-release"
                }]
            },
            {
                _name: "CSidebarNavItem",
                name: "Product",
                to: "/management/product",
                icon: "cil-grid"
            },
            {
                _name: "CSidebarNavItem",
                name: "Member POS",
                to: "/management/member-pos",
                icon: "cil-list"
            },
            {
                _name: "CSidebarNavItem",
                name: "Aggregator",
                to: "/management/aggregator",
                icon: "cil-justify-center"
            },
            // info : disabled feature waiting follow up user for enabling
            // electronicDeliveryOrderSideBarNav,
        ]
    }
}
